export default __webpack_public_path__ + "static/media/Qualifications.a9ec272c.png";